import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import language files directly for better type support
import enTranslation from './locales/en/translation.json';
import ruTranslation from './locales/ru/translation.json';
import jaTranslation from './locales/ja/translation.json';
import zhTranslation from './locales/zh/translation.json';
import deTranslation from './locales/de/translation.json';
import frTranslation from './locales/fr/translation.json';

// Resources for all languages
const resources = {
  en: {
    translation: enTranslation
  },
  ru: {
    translation: ruTranslation
  },
  ja: {
    translation: jaTranslation
  },
  zh: {
    translation: zhTranslation
  },
  de: {
    translation: deTranslation
  },
  fr: {
    translation: frTranslation
  }
};

// Define supported languages
const supportedLanguages = ['en', 'ru', 'ja', 'zh', 'de', 'fr'];

// Get language from localStorage
const savedLanguage = localStorage.getItem('language');

// Get browser language
const detectedLanguage = navigator.language.split('-')[0];

// Set default language
const defaultLanguage = supportedLanguages.includes(detectedLanguage) ? detectedLanguage : 'en';

i18n
  // Load translations from server
  .use(Backend)
  // Auto-detect user language
  .use(LanguageDetector)
  // Integrate with React
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    // Default language - first from localStorage, then from browser, or English
    lng: savedLanguage || defaultLanguage,
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    },
    detection: {
      // Language detection order
      order: ['localStorage', 'navigator'],
      // Key for localStorage
      lookupLocalStorage: 'language',
      // Save selected language to localStorage
      caches: ['localStorage']
    }
  });

export default i18n; 